<!--  personalized section-->
<div>
	<!-- Line Aid Selection -->
	<fieldset class="attribute-group-container" *ngIf="hasPersonalizedLineAid">
			<legend class="attribute-name">Text Location</legend>
			<div class="text-location-wrapper">
				<hmf-selectable
					[options]="[
						{ id: 1, value: 'None', selected: selectedLineAid === '1', classList: 'hmf-mx-s' },
				  		{ id: 2, value: 'StraightLine', selected: selectedLineAid === '2', classList: 'hmf-mx-s' },
				 		{ id: 3, value: 'TargetLine', selected: selectedLineAid === '3', classList: 'hmf-mx-s' },
					]"
					[multipleSelection]="false"
					[allowDeselection]="false"
					[shape]="'square'"
					[variant]="'text'"
					[contained]="true"
					[height]="'42px'"
					[minWidth]="'62px'"
					[spaceBetween]="'--hmf-xs'"
					[fillColor]="'--hmf-gray000'"
					[classList]="'hmf-body-m hmf-mr-0'"
					[optionsClassList]="'hmf-body-m'"
					(selectionChange)="handleHmfSelectableChange($event)"
				>
				</hmf-selectable>
			</div>
	</fieldset>

	<fieldset>
		<legend class="attribute-name">PERSONALIZATION</legend>
	<!--- Personalization Text -->
		<div *ngIf="hasPersonalizedText || hasPersonalizedLineAid" class="personalizedInputSection">
			<div class="personalization-text">
				<pdp-personalization-text-input
					id="textLine1"
					[attrLabel]="textLine1"
					[placeHolderText]="'Line 1'"
					[inputLabel]="'Line 1'"
					[isRequired]="true"
					[hasError]="getTextLineErrorMessage(1) && personalizedTextLine1.touched"
					[optionalText]="getTextLineErrorMessage(1) && personalizedTextLine1.touched ? getTextLineErrorMessage(1) : personalizedTextLine1CharsRemaining + ' characters remaining'">
					<input [formControl]="personalizedTextLine1" [maxlength]="personalizedTextCurrentCharLimit" (keyup)="debounceCheckPersonalizedLine(1)" (blur)="checkPersonalizedLine(1)">
				</pdp-personalization-text-input>
			</div>
			<div class="personalization-text" *ngIf="selectedLineAid === '1' || !hasPersonalizedLineAid">
				<pdp-personalization-text-input
					id="textLine2"
					[attrLabel]="textLine2"
					[placeHolderText]="'Line 2'"
					[inputLabel]="'Line 2'"
					[isRequired]="false"
					[isDisabled]="personalizedTextLine2.disabled"
					[hasError]="getTextLineErrorMessage(2) && personalizedTextLine2.touched"
					[optionalText]="getTextLineErrorMessage(2) && personalizedTextLine2.touched ? getTextLineErrorMessage(2) : personalizedTextLine2CharsRemaining + ' characters remaining'">
					<input [formControl]="personalizedTextLine2" [maxlength]="personalizedTextCurrentCharLimit" (keyup)="debounceCheckPersonalizedLine(2)" (blur)="checkPersonalizedLine(2)">
				</pdp-personalization-text-input>
			</div>
			<div class="personalization-text" *ngIf="selectedLineAid === '1' || !hasPersonalizedLineAid">
				<pdp-personalization-text-input
					id="textLine3"
					[attrLabel]="textLine3"
					[placeHolderText]="'Line 3'"
					[inputLabel]="'Line 3'"
					[isRequired]="false"
					[isDisabled]="personalizedTextLine3.disabled"
					[hasError]="getTextLineErrorMessage(3) && personalizedTextLine3.touched"
					[optionalText]="getTextLineErrorMessage(3) && personalizedTextLine3.touched ? getTextLineErrorMessage(3) : personalizedTextLine3CharsRemaining + ' characters remaining'">
					<input [formControl]="personalizedTextLine3" [maxlength]="personalizedTextCurrentCharLimit" (keyup)="debounceCheckPersonalizedLine(3)" (blur)="checkPersonalizedLine(3)">
				</pdp-personalization-text-input>
			</div>
		</div>

		<!--- Personalization Number -->
		<div *ngIf="hasPersonalizedNumber" >
				<pdp-personalization-text-input
					id="numberLine1"
					[attrLabel]="numberLine1"
					[placeHolderText]="'Personalized Number'"
					[inputLabel]="'Personalized Number'"
					[isRequired]="true"
					[isDisabled]="personalizedNumberLine.disabled"
					[hasError]="getNumberLineErrorMessage() && personalizedNumberLine.touched"
					[optionalText]="getNumberLineErrorMessage() && personalizedNumberLine.touched ? getNumberLineErrorMessage() : personalizedNumberLineCharsRemaining + ' characters remaining'">
					<input [formControl]="personalizedNumberLine" [maxlength]="personalizedTextCurrentCharLimit" (keyup)="debounceCheckPersonalizedLine()" (blur)="checkPersonalizedLine()">
				</pdp-personalization-text-input>
		</div>
	</fieldset>
	<div class="personalizedNumberMessage">
		<p *ngIf="hasPersonalizedNumber">
			<homefield-icon width="18px" height="18px" name="alert-error-outlined"></homefield-icon>
			Personalized Number not shown in preview. Please see product images for placement.
		</p>
	</div>
	<!-- Golf Ball Image -->
	<div class="golfBallImageContainer" *ngIf="hasPersonalizedText || hasPersonalizedLineAid">
		<img class="golfBallImage" [ngClass]="{'normal-image':selectedLineAid === '1','straight-image':selectedLineAid === '2','target-image':selectedLineAid === '3'}" src="assets/image/golf-ball-personalized.png" alt="Blank Golf Ball. Personalization text will overlay this image."/>

		<!-- plain text section-->
		<div class="golfBallOverlay" *ngIf="selectedLineAid === '1' || !hasPersonalizedLineAid">
			<p *ngIf="personalizedTextLine1CharsRemaining < personalizedTextCharLimit" aria-label="Text preview line 1:" [ngStyle]="{'color': selectSelectedTextColorAttribute$ | async }" [ngClass]="{'hmf-text-transform-uppercase': personalizedTextCase === 'upper'}">{{personalizedTextLine1?.value}}</p>
			<p *ngIf="personalizedTextLine2CharsRemaining < personalizedTextCharLimit" aria-label="Text preview line 2:" [ngStyle]="{'color': selectSelectedTextColorAttribute$ | async }" [ngClass]="{'hmf-text-transform-uppercase': personalizedTextCase === 'upper'}">{{personalizedTextLine2?.value}}</p>
			<p *ngIf="personalizedTextLine3CharsRemaining < personalizedTextCharLimit" aria-label="Text preview line 3:" [ngStyle]="{'color': selectSelectedTextColorAttribute$ | async }" [ngClass]="{'hmf-text-transform-uppercase': personalizedTextCase === 'upper'}">{{personalizedTextLine3?.value}}</p>
		</div>

		<!-- Straight text section-->
		<div class="golfBallOverlay stLine" *ngIf="selectedLineAid === '2'">
			<div class="left leftRadius"></div>
			<div class="lineOne golf-ball-text" [ngStyle]="{'color': selectSelectedTextColorAttribute$ | async }" [ngClass]="{'hmf-text-transform-uppercase': personalizedTextCase === 'upper'}">{{personalizedTextLine1?.value}}</div>
			<div class="right rightRadius"></div>
		</div>

		<!-- Targetline text section-->
		<div class="golfBallOverlay targetLine" *ngIf="selectedLineAid === '3'">
			<div class="targetVRadius"></div>
			<div><div class="left targetLeftRadius"></div>
				<div class="lineOne golf-ball-text" [ngStyle]="{'color': selectSelectedTextColorAttribute$ | async }" [ngClass]="{'hmf-text-transform-uppercase': personalizedTextCase === 'upper'}">{{personalizedTextLine1?.value}}</div>
				<div class="right targetRightRadius"></div>
			</div>
			<div class="targetBRadius"></div>
		</div>
	</div>

</div>
